import { Link } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { CompetitorInsight } from '../../types';
import { BrandFavicon } from '../BrandFavicon';
import { SettingsCard } from './SettingsCard';
import { useTrackerAiPath } from '../../utils/paths';

export function SettingsCompetitorsPreview({
  competitors,
  loading,
  onAdd,
  onEdit,
}: {
  competitors: CompetitorInsight[];
  loading?: boolean;
  onAdd: () => void;
  onEdit: (competitor: CompetitorInsight) => void;
}) {
  const toTrackerAi = useTrackerAiPath();
  return (
    <SettingsCard
      title="رقبا"
      helpKey="competitors_settings"
      description="برندهایی که دیده‌شدن آن‌ها در AI را ردیابی می‌کنید."
    >
      <div className="d-flex flex-column gap-3">
        {loading ? (
          <p className="fs--1 text-600 mb-0">درحال بارگذاری</p>
        ) : competitors.length === 0 ? (
          <p className="fs--1 text-600 mb-0">هنوز رقیبی اضافه نشده.</p>
        ) : (
          <ul className="list-unstyled d-flex flex-wrap gap-3 mb-0">
            {competitors.map((competitor, index) => (
              <li key={competitor.id} className="position-relative">
                <div
                  className="d-flex flex-column align-items-center text-center rounded-3 border bg-100 dark__bg-1100 px-3 py-3"
                  style={{ width: '10rem' }}
                >
                  <Button
                    type="button"
                    variant="link"
                    size="sm"
                    onClick={() => onEdit(competitor)}
                    className="position-absolute top-0 end-0 mt-1 me-1 p-1 text-500"
                    aria-label={`ویرایش ${competitor.brandName}`}
                    title="ویرایش رقیب"
                  >
                    <FontAwesomeIcon icon="pen" className="fs--2" />
                  </Button>
                  <BrandFavicon host={competitor.host} name={competitor.brandName} colorIndex={index} />
                  <p className="mt-2 w-100 text-truncate fs--1 fw-medium text-1000 mb-0">
                    {competitor.brandName}
                  </p>
                  <p className="w-100 text-truncate fs--2 text-600 mb-0">{competitor.host}</p>
                </div>
              </li>
            ))}
          </ul>
        )}
        <div className="d-flex flex-wrap gap-2 border-top pt-3">
          <Link to={toTrackerAi('competitors')} className="btn btn-primary btn-sm fs--1 py-1 px-2">
            مدیریت رقبا
          </Link>
          <Button
            type="button"
            variant="outline-primary"
            size="sm"
            className="fs--1 py-1 px-2"
            onClick={onAdd}
          >
            + افزودن رقیب
          </Button>
        </div>
      </div>
    </SettingsCard>
  );
}
